import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle(event) {
    event.preventDefault()
    
    if (this.menuTarget.style.display === "none") {
      this.menuTarget.style.display = "block"
      this.iconTarget.style.transform = "rotate(180deg)"
      this.setCookie("adminSubmenuOpen", "true", 365)
    } else {
      this.menuTarget.style.display = "none"
      this.iconTarget.style.transform = "rotate(0deg)"
      this.setCookie("adminSubmenuOpen", "false", 365)
    }
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = "expires=" + date.toUTCString()
    document.cookie = name + "=" + value + ";" + expires + ";path=/"
  }
}
